// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"262":"c1f5d8da","776":"5743b79c"}[chunkId] + ".chunk.css";
};